import { notEmpty } from "@product/scmp-sdk";
import type { ReadonlyURLSearchParams } from "next/navigation";

import type { PlusDetailedListing } from "./types";

export const QueryParameterName = "plus-detail";
export const QuerySeparator = ":";

export function decodePlusDetailedListingQuery(
  searchParameters: ReadonlyURLSearchParams,
): PlusDetailedListing | undefined {
  const plusDetailQueryString = searchParameters.get(QueryParameterName) ?? "";
  const [type, entityUuid] = plusDetailQueryString.split(QuerySeparator).filter(notEmpty);

  switch (type) {
    case "author":
    case "daily-pulse":
    case "fact-sheet":
    case "featured-opinion":
    case "quick-digest":
    case "topic":
      return { entityUuid, type };
  }
}

export function encodePlusDetailedListingQuery(plusDetailedListing: PlusDetailedListing) {
  const { type: _type, ...rest } = plusDetailedListing;
  switch (plusDetailedListing.type) {
    case "author":
    case "topic":
      return {
        [QueryParameterName]: [plusDetailedListing.type, plusDetailedListing.entityUuid].join(
          QuerySeparator,
        ),
        ...rest,
      };
    case "daily-pulse":
    case "fact-sheet":
    case "featured-opinion":
    case "quick-digest":
      return { [QueryParameterName]: plusDetailedListing.type, ...rest };
  }
}

type EncodedPlusDetailedListingQuery = ReturnType<typeof encodePlusDetailedListingQuery>;

/** ref: https://stackoverflow.com/a/49402091/5235017 */
type KeysOfUnion<T> = T extends T ? keyof T : never;

type KeysOfEncodedPlusDetailedListingQuery = Array<KeysOfUnion<EncodedPlusDetailedListingQuery>>;

export const keysOfEncodedPlusDetailedListingQuery: KeysOfEncodedPlusDetailedListingQuery = [
  QueryParameterName,
  "entityUuid",
  "pgtype",
];
